<template>
    <div>
        <card-header title="Add-On Participants" icon="fa-street-view"/>

        <card-body>
            <card-list>
                <container-list-item padded v-if="notFound">
                    <i class="fas fa-exclamation-triangle mr-2"></i>This add-on no longer exists. It may have been deleted.
                </container-list-item>
                <trip-add-on-list-item
                    v-if="!notFound"
                    :card="card"
                    :addon="addon"
                    context
                />
                <subheader-list-item title="Participants" icon="fas fa-street-view"/>

                <reg-add-on-list-item
                    :card="card"
                    :addon="addon"
                    v-for="addon in addon.participants"
                    :active="(child && child.definition.component === 'edit-addon') && child.props.addonId === addon.id.toString()"
                    @click="$openCard('edit-addon', {registrationId: addon.registration_id, addonId: addon.id}, card)"
                    show-user
                />
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import TripListItem from "@/components/TripListItem";

    import {client as http} from '@/http_client';
    import CardBody from "@/TIER/components/CardBody";
    import TripResponseListItem from "@/components/TripResponseListItem";
    import QuestionListItem from "@/components/QuestionListItem";
    import TripAddOnListItem from "@/components/TripAddOnListItem";
    import RegAddOnListItem from "@/components/RegAddOnListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";

    export default {
        props: ['card', 'child', 'props'],
        components: {ContainerListItem, RegAddOnListItem, TripAddOnListItem, CardBody, TripListItem, SubheaderListItem, CardList, CardHeader},
        data: function() {
            return {
                addon: {
                    participants: []
                },
                notFound: false
            };
        },
        methods: {
            loadAddon: function(force) {
                this.$emit('loading', true);
                this.notFound = false;
                http.get('/api/addons/' + this.props.addonId, {force}).then(response => {
                    this.addon = response.data;
                    this.$emit('loading', false);
                }).catch(err => {
                    this.notFound = true;
                    this.$emit('loading', false);
                });
            },
            reload: function() {
                this.loadAddon(true);
            }
        },
        watch: {
            'props.addonId': function() {
                this.loadAddon(true);
            }
        },
        mounted() {
            this.loadAddon();
        }
    };
</script>

<style lang="scss" scoped>

</style>
